"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Profile = _interopRequireDefault(require("../Profile"));
var _NavDropdown = _interopRequireDefault(require("../NavDropdown"));
var _getUserInitials = _interopRequireDefault(require("../../utils/getUserInitials"));
var _constants = _interopRequireDefault(require("../../utils/constants"));
var _LumeThemeService = _interopRequireDefault(require("../LumeThemeService/LumeThemeService"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var styles = {
  "loginContainer": "styles__loginContainer__7zYEE",
  "login": "styles__login__B-ZB-",
  "item-profile": "styles__item-profile__QR6iM",
  "itemProfile": "styles__item-profile__QR6iM",
  "profile-initials": "styles__profile-initials__7UJjp",
  "profileInitials": "styles__profile-initials__7UJjp",
  "hidden-text": "styles__hidden-text__uqtdh",
  "hiddenText": "styles__hidden-text__uqtdh"
}; 
require('./styles.css');
var displayName = 'ProfileDropdown';
var LoginText = 'Login';
var propTypes = {
  profile: _propTypes["default"].shape({}),
  isStudio: _propTypes["default"].bool,
  showSubscriptionAndUsageLink: _propTypes["default"].bool,
  lumeThemeService: _LumeThemeService["default"],
  isOneTrustEnabled: _propTypes["default"].bool,
  onSignin: _propTypes["default"].func,
  onSignout: _propTypes["default"].func,
  signInLink: _propTypes["default"].string,
  signOutLink: _propTypes["default"].string,
  classNames: _propTypes["default"].shape({
    loginLink: _propTypes["default"].string
  })
};
var defaultProps = {
  profile: null,
  isStudio: false,
  showSubscriptionAndUsageLink: false,
  lumeThemeService: null,
  isOneTrustEnabled: false,
  onSignin: null,
  onSignout: null,
  signInLink: '',
  signOutLink: '',
  classNames: {
    loginLink: ''
  }
};
var ProfileDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(ProfileDropdown, _React$Component);
  var _super = _createSuper(ProfileDropdown);
  function ProfileDropdown(props) {
    var _this;
    _classCallCheck(this, ProfileDropdown);
    _this = _super.call(this, props);
    _this.navProfileRef = null;
    _this.dropdownRef = null;
    return _this;
  }
  _createClass(ProfileDropdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        profile = _this$props.profile,
        isStudio = _this$props.isStudio,
        showSubscriptionAndUsageLink = _this$props.showSubscriptionAndUsageLink,
        lumeThemeService = _this$props.lumeThemeService,
        isOneTrustEnabled = _this$props.isOneTrustEnabled,
        signInLink = _this$props.signInLink,
        classNames = _this$props.classNames,
        onSignin = _this$props.onSignin,
        onSignout = _this$props.onSignout,
        signOutLink = _this$props.signOutLink;
      if (!profile) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: styles.loginContainer
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: signInLink || _constants["default"].defaultSignInLink,
          className: (0, _classnames["default"])(styles.login, classNames.loginLink),
          onClick: onSignin,
          "data-test-id": "navbar-login"
        }, LoginText));
      }
      var userInitials = (0, _getUserInitials["default"])(profile);
      var profileComponent = /*#__PURE__*/_react["default"].createElement(_Profile["default"], {
        profile: profile,
        isStudio: isStudio,
        showSubscriptionAndUsageLink: showSubscriptionAndUsageLink,
        lumeThemeService: lumeThemeService,
        isOneTrustEnabled: isOneTrustEnabled,
        userInitials: userInitials,
        onSignout: onSignout,
        signOutLink: signOutLink
      });
      return /*#__PURE__*/_react["default"].createElement(_NavDropdown["default"], {
        className: styles.itemProfile,
        content: profileComponent,
        testId: "navbar-profile",
        "data-test-id": "navbar-profile-dropdown-container"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])(styles.profileInitials, 'fs-block'),
        title: "Profile"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])(styles.hiddenText)
      }, "Profile: "), userInitials));
    }
  }]);
  return ProfileDropdown;
}(_react["default"].Component);
ProfileDropdown.displayName = displayName;
ProfileDropdown.defaultProps = defaultProps;
ProfileDropdown.propTypes = propTypes;
var _default = exports["default"] = ProfileDropdown;
//# sourceMappingURL=ProfileDropdown.js.map